import Vue from 'vue'
// import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/src/stylus/app.styl'

import VueResource from 'vue-resource';
Vue.use(VueResource);
Vue.http.options.emulateJSON = true;

import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

import SecureImage from './components/SecureImage';
Vue.component('sec-img', SecureImage)

Vue.config.productionTip = false

Vue.prototype.$store = store;

import {setupI18n} from './locale';

export function setup(config, versions) {

  Sentry.init({ dsn: config.sentryDsn || 'https://bb03e018231144619ddcccf24c969016@sentry.io/1455121' });

  config.menu
    .filter(x => x.component instanceof Function)
    .forEach(x => Vue.component(x.name, x.component))

  config.topMenu
    .filter(x => x.component instanceof Function)
    .forEach(x => Vue.component(x.name, x.component))

  const customLocales = config.i18n && config.i18n.messages;
  const i18n = setupI18n(customLocales);

  Vue.use(Vuetify, {
    options: {
      customProperties: true,
    },
    iconfont: 'md',
    lang: {
      t: (key, ...params) => i18n.t(key, params)
    }
  });

  new Vue({
    i18n,
    render: h => h(App),
    data() {
      return {
        session: JSON.parse(localStorage.getItem('session') || sessionStorage.getItem('session') || '{}'),
        config,
        versions,
      }
    },
    created() {

      Vue.http.interceptors.push((request, next) => {
        console.log('session token', this.sessionToken);
        request.headers.set('X-Auth', 'Bearer ' + this.sessionToken);

        next(function(response) {
          if (response.status === 401) {
            this.clearSession();
          }
        });
      });

      document.title = config.documentTitle;

      console.log(this.session);

      //Auto-login
      if (!this.hasSession) {
        this.$http.post(this.$root.route('auth'), {token: this.sessionToken})
          .then(
            // Success
            response => {
              console.log('Session recovered');
              this.registerSession(response.body.result);
            },
            // Failure
            response => {
              // Session expired
              console.log('Session expired');
              this.clearSession();
            }
          );
      }
    },
    computed: {
      hasSession() {
        return typeof this.session.token !== 'undefined';
      },
      sessionToken() {
        return this.session.ID && this.session.token ? this.session.ID + ':' + this.session.token : null;
      },
      avatar() {
        return (this.hasSession && typeof this.session.avatar === 'string') ? this.session.avatar : false;
      },
      globalComponent() {
        return this.$children[0]
      }
    },

    methods: {
      visibleIcon(isPinVisible) {
        return isPinVisible
          ? require(`./assets/eye.svg`)
          : require(`./assets/eye-off.svg`);
      },
      registerSession(session, persist) {
        this.session = session;

        localStorage.removeItem('session');
        sessionStorage.removeItem('session');
        if (persist) {
          localStorage.setItem('session', JSON.stringify(session));
        } else {
          sessionStorage.setItem('session', JSON.stringify(session));
        }
      },
      clearSession() {
        localStorage.removeItem('session');
        sessionStorage.removeItem('session');
        this.session = {};
      },
      route(route) {
        console.log('Route: ' + config.api.url + route, this.$i18n)
        const lang = ((this.$i18n.messages[this.$i18n.locale] || {}).Lang || {}).iso;
        return config.api.url + route + (route.indexOf('?') < 0 ? '?' : '&') + 'language=' + encodeURIComponent(lang);
      }
    }
  }).$mount('#app')
}
